import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

const bancos = [
  { label: "Banco BICE", value: "BANCO_BICE", sbif: "0028" },
  { label: "Banco Consorcio", value: "BANCO_CONSORCIO", sbif: "0055" },
  { label: "Banco Corpbanca", value: "BANCO_CORPBANCA", sbif: "0027" },
  {
    label: "Banco Crédito e Inversiones (BCI)",
    value: "BANCO_CREDITO_E_INVERSIONES",
    sbif: "0016"
  },
  { label: "Banco Estado", value: "BANCO_ESTADO", sbif: "0012" },
  { label: "Banco Falabella", value: "BANCO_FALABELLA", sbif: "0051" },
  { label: "Banco Internacional", value: "BANCO_INTERNACIONAL", sbif: "0009" },
  { label: "Banco Ripley", value: "BANCO_RIPLEY", sbif: "0053" },
  { label: "Banco Santander", value: "BANCO_SANTANDER", sbif: "0037" },
  { label: "Banco Security", value: "BANCO_SECURITY", sbif: "0049" },
  { label: "Banco de Chile", value: "BANCO_DE_CHILE", sbif: "0001" },
  { label: "Itaú", value: "ITAU", sbif: "0039" },
  { label: "Scotiabank", value: "SCOTIABANK", sbif: "0014" }
];

const SelectBanco = ({
  id = "--select-banco",
  className,
  disabled,
  variant,
  required,
  placeholder,
  size,
  error,
  helperText,
  value,
  onChange = () => {},
  onBlur = () => {}
}) => {
  return (
    <Autocomplete
      id={id}
      className={className}
      disabled={disabled}
      options={bancos}
      getOptionLabel={option => (option.label ? option.label : option)}
      value={value}
      onChange={(_, value) => onChange(value)}
      onBlur={onBlur}
      renderInput={params => (
        <TextField
          {...params}
          required={required}
          fullWidth
          label="Banco"
          placeholder={placeholder}
          size={size}
          variant={variant}
          InputLabelProps={{
            shrink: Boolean(value) || Boolean(placeholder) || document.activeElement.id === id
          }}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};

export const getBanco = value => bancos.filter(b => b.value === value)[0] || null;

export default SelectBanco;
